var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    transform: "matrix(1, 0, 0, 1, 0, 0)rotate(0)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236 342",
    style: {
      enableBackground: "new 0 0 236 342"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7A7A7A;stroke:#7A7A7A;stroke-width:0.651;stroke-miterlimit:2.6042;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.3,338.7v-29.5c30.1-1.6,53.1-9.8,70.8-24.6s26.6-34.6,26.6-57.4c0-24.6-7.2-42.8-23-54.3 c-16-13.1-38.9-23-72.7-29.5h-1.7V67.7c23,3.3,42.5,9.8,61.9,23l28.4-36.1c-28.4-18.2-58.5-27.9-90.4-29.5V5.3h-26.6v19.7 C82.1,26.6,59,34.8,41.3,49.7s-26.6,34.6-26.6,57.4s7.2,41,23,52.5c14.1,11.5,38.9,21.3,70.8,27.9v77.1 c-24.9-3.3-49.7-14.8-74.3-34.6L2.3,264.7c31.8,26.4,67.4,41,106.3,44.3v29.6H135.3L135.3,338.7z M137,195.7 c17.7,4.9,28.4,9.8,35.4,14.8c5.3,6.6,8.9,13.1,8.9,23s-3.6,16.4-12.4,23c-8.9,6.6-19.6,9.8-31.8,11.5V195.7z M75.1,125.1 c-5.3-4.9-8.9-13.1-8.9-21.3c0-9.8,3.6-16.4,10.5-23c8.9-6.6,17.7-9.8,31.8-11.5V140C90.9,134.9,80.4,130,75.1,125.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.6f22edf66ac07f687816e767cd18af5d.svg";
export { ForwardRef as ReactComponent };